define.alias("shared/components/shared/mobile/drawer/feature-drawer", "preview-grid/components/shared/mobile/drawer/feature-drawer");